import { Link, useLocation, useNavigate } from "react-router-dom";
import { useLang } from "@/i18n";
import { scrollToId } from "@/lib/scroll";
import BrandMark from "@/components/BrandMark";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();
  const targets = ["#metodo", "#programmi", "#community", "#professionisti", "#faq"];

  const go = (id) => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else {
      scrollToId(id);
    }
  };

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="shell footer-main">
        <button className="brand footer-brand" onClick={() => go("#top")} aria-label="Tech Training" data-testid="footer-brand">
          <BrandMark />
          <span className="brand-name">TECH <strong>TRAINING</strong></span>
        </button>
        <p>{t.footer.tagline}</p>
        <nav aria-label="Footer">
          {t.footer.nav.map((label, i) => (
            <button key={label} onClick={() => go(targets[i])} data-testid={`footer-nav-${i}`}>
              {label}
            </button>
          ))}
        </nav>
        <a className="footer-email" href="mailto:info@innoversegroup.it" data-testid="footer-email">
          info@innoversegroup.it ↗
        </a>
      </div>
      <div className="shell footer-bottom">
        <span>© {year} {t.footer.rights}</span>
        <span className="footer-legal">
          <Link to="/privacy" data-testid="footer-link-privacy">Privacy Policy</Link>
          <Link to="/cookie-policy" data-testid="footer-link-cookie">Cookie Policy</Link>
        </span>
        <span>{t.footer.project}</span>
      </div>
    </footer>
  );
};

export default Footer;
